import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'compactCurrency' })
export class CompactCurrencyPipe implements PipeTransform {
  transform(value: number | string | null | undefined, currencySymbol: string = '$', fractionDigits: number = 2): string {
    const numericValue = Number(value);
    if (value === null || value === undefined || Number.isNaN(numericValue)) {
      return `${currencySymbol}0`;
    }

    const absValue = Math.abs(numericValue);
    const sign = numericValue < 0 ? '-' : '';

    if (absValue >= 1_000_000_000) {
      return `${sign}${currencySymbol}${(absValue / 1_000_000_000).toFixed(fractionDigits)}bn`;
    }

    if (absValue >= 1_000_000) {
      return `${sign}${currencySymbol}${(absValue / 1_000_000).toFixed(fractionDigits)}mn`;
    }

    return `${sign}${currencySymbol}${absValue.toLocaleString('en-US')}`;
  }
}
